import React, { useState } from 'react';
import { MessageCircle, X, Send, HelpCircle, Mail, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const SupportWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState('menu');
  const [message, setMessage] = useState('');

  const quickActions = [
    { icon: HelpCircle, label: 'Browse FAQs', action: () => window.location.href = '/help' },
    { icon: MessageCircle, label: 'Start Chat', action: () => setView('chat') },
    { icon: Mail, label: 'Send Email', action: () => setView('contact') },
    { icon: Phone, label: 'Call Us', action: () => window.location.href = 'tel:+15553606377' }
  ];

  return (
    <>
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-primary hover:bg-primary/90 rounded-full shadow-lg flex items-center justify-center transition-transform hover:scale-110"
        >
          <MessageCircle className="h-6 w-6 text-gray-900" />
        </button>
      )}

      {isOpen && (
        <div className="fixed bottom-6 right-6 z-50 w-96 max-h-[600px] shadow-2xl rounded-lg overflow-hidden">
          <Card className="h-full">
            <CardHeader className="bg-primary text-gray-900 flex flex-row items-center justify-between py-4">
              <div className="flex items-center space-x-2">
                <MessageCircle className="h-5 w-5" />
                <CardTitle className="text-lg">Need Help?</CardTitle>
              </div>
              <button
                onClick={() => {
                  setIsOpen(false);
                  setView('menu');
                }}
                className="hover:bg-white/20 rounded-full p-1 transition-colors"
              >
                <X className="h-5 w-5" />
              </button>
            </CardHeader>

            <CardContent className="p-0">
              {view === 'menu' && (
                <div className="p-4 space-y-2">
                  <p className="text-sm text-gray-600 mb-4">
                    How can we assist you today?
                  </p>
                  {quickActions.map((action, index) => (
                    <button
                      key={index}
                      onClick={action.action}
                      className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors text-left"
                    >
                      <action.icon className="h-5 w-5 text-primary" />
                      <span className="text-sm font-medium text-gray-900">{action.label}</span>
                    </button>
                  ))}
                  
                  <div className="pt-4 border-t border-gray-200 mt-4">
                    <p className="text-xs text-gray-500 text-center">
                      Available Mon-Sat, 9am-7pm EST
                    </p>
                  </div>
                </div>
              )}

              {view === 'chat' && (
                <div className="flex flex-col h-96">
                  <div className="flex-1 p-4 overflow-y-auto bg-gray-50">
                    <div className="space-y-4">
                      <div className="flex items-start space-x-2">
                        <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                          <MessageCircle className="h-4 w-4 text-gray-900" />
                        </div>
                        <div className="bg-white rounded-lg p-3 max-w-xs shadow-sm">
                          <p className="text-sm text-gray-900">
                            Hi! I'm here to help. What question do you have?
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="p-4 border-t border-gray-200 bg-white">
                    <div className="flex space-x-2">
                      <Input
                        placeholder="Type your message..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        className="flex-1"
                      />
                      <Button size="sm" className="bg-primary">
                        <Send className="h-4 w-4" />
                      </Button>
                    </div>
                    <button
                      onClick={() => setView('menu')}
                      className="text-xs text-gray-500 hover:text-gray-700 mt-2"
                    >
                      ← Back to menu
                    </button>
                  </div>
                </div>
              )}

              {view === 'contact' && (
                <div className="p-4 space-y-4">
                  <Input placeholder="Your Name" />
                  <Input type="email" placeholder="Your Email" />
                  <Textarea placeholder="Your Message" rows={4} />
                  <Button className="w-full bg-primary">
                    <Send className="mr-2 h-4 w-4" />
                    Send Message
                  </Button>
                  <button
                    onClick={() => setView('menu')}
                    className="text-xs text-gray-500 hover:text-gray-700 w-full text-center"
                  >
                    ← Back to menu
                  </button>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      )}
    </>
  );
};

export default SupportWidget;
